import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyManagerResult,
	CompanyManagersState,
} from '@localTypes/companyManagers';

const initialState: CompanyManagersState = {};

export const companyManagersSlice = createSlice({
	initialState,
	name: 'company_managers',
	reducers: {
		clearManagers: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isError = isError;
		},
		setLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isLoading = isLoading;
		},
		setManagers: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyManagerResult['result'];
			total: number;
		}>) => {
			const {
				companyId,
				result,
				total,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
				total,
			};
		},
	},
});

export const {
	clearManagers,
	setError,
	setLoading,
	setManagers,
} = companyManagersSlice.actions;

export const companyManagersReducer = companyManagersSlice.reducer;
